import classNames from 'classnames'
import { bool, string } from 'prop-types'

import useMediaPath from '../../hooks/useMediaPath'

import './ProgressItem.scss'

export default function ProgressItem({ label, disabled, simple, color }) {
    const mediaPath = useMediaPath()
    return (
        <div className={classNames('progressItem', { disabled, simple })}>
            <div className='label'>
                <img
                    src={
                        disabled
                            ? mediaPath([
                                  '/assets/icons/checked-grey.svg',
                                  '/assets/images/padel/icons/checked-grey.svg',
                                  '/assets/icons/checked-grey.svg',
                              ])
                            : mediaPath([
                                  '/assets/icons/checked-green.svg',
                                  '/assets/images/padel/icons/checked-red.svg',
                                  '/assets/icons/checked-green.svg',
                              ])
                    }
                />
                <div className='text'>{label}</div>
            </div>
            {!simple && <div className='bar' style={{ backgroundColor: color }}></div>}
        </div>
    )
}

ProgressItem.propTypes = {
    color: string,
    disabled: bool,
    label: string,
    simple: bool,
}
